export const DiscountTypes = {
  PERCENTAGE: "PERCENTAGE",
  PRICE: "PRICE"
};
